<template lang="pug">
.tone-window
  window(v-for="fitsImage in frameStore.fitsImages", :key="Id(fitsImage)", :zGroup=1, :title="fitsImage.name", :isOpen="fitsImage.toneWindow", :closeButton="true", @closebuttonclick="fitsImage.toneWindow = false")
    .tools
      | Type: &nbsp;
      select(v-model="fitsImage.tone.type")
        option(value="linear") Linear
        option(value="asinh") asinh
      .padding
      button-menu
        menu-item(label="Reset", @click="fitsImage.resetTone")
    template(v-if="fitsImage.tone.type == 'linear'")
      table
        tr
          th A
          td
            log-scale-range(v-model="fitsImage.tone.linear.contrast", :min="0", :max="1.e+5", :a="1.e+1", style="min-width: 200px;")
        tr
          th b
          td
            log-scale-range(v-model="fitsImage.tone.linear.bias", :min="-1", :max="1", :a="1.e-8")
    template(v-if="fitsImage.tone.type == 'asinh'")
      table
        tr
          th &beta;
          td
            log-scale-range(v-model="fitsImage.tone.asinh.beta", :min="0", :max="2.e+7", style="min-width: 200px;")
        tr
          th b<sub>0</sub>
          td
            log-scale-range(v-model.number="fitsImage.tone.asinh.b0", :min="-1", :max="1", :a="1.e-9")
        tr
          th A
          td
            log-scale-range(v-model.number="fitsImage.tone.asinh.a", :min="0", :max="1.e3", :a="1.e+1")
        tr
          th bias
          td
            log-scale-range(v-model.number="fitsImage.tone.asinh.bias", :min="-0.5", :max="0.5", :a="1.e-8")
</template>
          
<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { FitsImageModule } from '@/modules/FitsImageModule';
import { FrameStore } from '@/modules/base';
import { FitsImage } from '@/modules/FitsImageModule/FitsImage';

@Component
export default class extends Vue {
  @Prop({ required: true })
  module!: FitsImageModule

  @Prop({ required: true })
  frameStore!: FrameStore<typeof FitsImageModule>
}
</script>


<style lang="scss" scoped>
table {
  width: 100%;
}

th {
  width: 20%;
}

.tools {
  display: flex;
}
.padding {
  flex-grow: 1;
}
</style>